// libs
import ViewportFixed from '../_libs/ViewportFixed';
import AnchorScroll from '../_libs/AnchorScroll';
import Accordion from '../_libs/Accordion';

// utils
import BrowserCheck from './BrowserCheck';

const html = document.documentElement;

const BrowserCheckObj = BrowserCheck();

// 初期設定
function init() {
	document.addEventListener('DOMContentLoaded', () => {
		// brタグの読み上げ防止
		const elements = document.querySelectorAll('br');
		elements.forEach((el) => {
			el.setAttribute('aria-hidden', 'true');
		});

		// スクロールバーを抜いた横幅を取得
		const setFillWidth = () => {
			const vw = Math.floor(document.documentElement.clientWidth);
			document.documentElement.style.setProperty('--vw', `${vw}px`);
		};
		setFillWidth();

		let vw = document.documentElement.clientWidth;
		window.addEventListener('resize', () => {
			if (vw === document.documentElement.clientWidth) {
				return;
			}
			vw = document.documentElement.clientWidth;
			setFillWidth();
		});

		// タッチデバイスの場合
		if (BrowserCheckObj?.phone || BrowserCheckObj?.tablet) {
			html.classList.add('isTouchable');
		}
		// iosの場合
		if (BrowserCheckObj?.apple.device) {
			html.classList.add('isIos');
		}
		// Safariの場合
		if (BrowserCheckObj?.safari) {
			html.classList.add('isSafari');
		}

		setTimeout(() => {
			document.body.classList.remove('preload');

			setTimeout(() => {
				html.classList.add('isLoaded');
			}, 200);
		}, 0);
	});

	if (!window.matchMedia('(min-width: 768px)').matches) {
		Accordion({
			base: '.js-accordion-footer',
			trigger: '.js-accordion-footer-trigger',
			target: '.js-accordion-footer-target',
			option: false,
		});
	}

	window.addEventListener('load', () => {
		AnchorScroll('.js-anchor-scroll', 0);
	});
}

// libsの読み込み
function loadLibs() {
	document.addEventListener('DOMContentLoaded', () => {
		// viewport固定（フルリキッドの場合はなし）
		ViewportFixed();
	});

	window.addEventListener('load', () => {});
}

export default function Foundation() {
	init();
	loadLibs();
}
